<p class="description">{{ description }}</p>
<div class="content">
  <h2 class="label">{{ label }}</h2>
  <p class="info">{{ infoText }}</p>
</div>
